import type { StatamicAssets, StatamicAsset } from "@customTypes/statamic";
import type { EventEntry } from "../types/entries";
import { convertStatamicAssetToCDN } from "./cdn";

/**
 * General utilities
 * -----------------------------------------------------------------------------
 */

export function getForMenOrWomen(event: EventEntry) {
  return event.topics.some((topic) => topic.title === "For Men")
    ? "For Men"
    : "For Women";
}

export function getSubsplashEmbedUrl(short_code: string) {
  return `https://subsplash.com/+f83c/embed/mi/+${short_code}?autoplay&audio&video&shareable&embeddable`;
}

/** Given a StatamicAssets object, get the first StatamicAsset. */
function getFirstAsset(assets: StatamicAssets | null): StatamicAsset | null {
  if (Array.isArray(assets)) {
    return assets[0] || null;
  }
  return assets;
}

/** Given a StatamicAssets object, get the image URL of the first StatamicAsset. */
export function getFirstAssetImageURL(
  assets: StatamicAssets | null,
): string | undefined {
  const asset = getFirstAsset(assets);
  if (!asset) {
    return;
  }
  return convertStatamicAssetToCDN(asset.id);
}

interface Page {
  name: string;
  href: string;
}
export function ellipsifyPagination(pages: Page[], pageIndex: number = 1) {
  const pageCountAtEnd = 1;
  const pageCountSideOfCurrent = 1;
  return pages.reduce(
    (acc, page, index) => {
      const isStartingIndex = index < pageCountAtEnd;
      const isStartEllipsis = index === pageCountAtEnd;
      const isEndingIndex = index > pages.length - 1 - pageCountAtEnd;
      const isEndEllipsis = index === pages.length - 1 - pageCountAtEnd;
      const isCloseToCurrentPage =
        Math.abs(index - pageIndex) <= pageCountSideOfCurrent;
      const isLastEntryEllipsis = acc[acc.length - 1]?.name === "...";

      if (isStartingIndex || isEndingIndex || isCloseToCurrentPage) {
        acc.push({
          name: page.name,
          href: page.href,
          active: index === pageIndex,
        });
      } else if ((isStartEllipsis || isEndEllipsis) && !isLastEntryEllipsis) {
        acc.push({
          name: "...",
          href: "",
          active: false,
        });
      }

      return acc;
    },
    [] as { name: string; href: string; active: boolean }[],
  );
}
